import { CareerImageProps, JobPostProps } from "@/types/career/career.type";

/** Structural-only — gallery images for the careers banner. */
export const careerData: CareerImageProps[] = [
  {
    imageUrl: "/assets/career/career-1.avif",
    altText: "Team collaboration at Build Web IT",
  },
  {
    imageUrl: "/assets/career/career-2.avif",
    altText: "Focused work at Build Web IT",
  },
  {
    imageUrl: "/assets/career/career-3.avif",
    altText: "Creative design at Build Web IT",
  },
  {
    imageUrl: "/assets/career/career-4.avif",
    altText: "Diverse team at Build Web IT",
  },
  {
    imageUrl: "/assets/career/career-5.avif",
    altText: "Diverse team at Build Web IT",
  },
  {
    imageUrl: "/assets/career/career-6.avif",
    altText: "Diverse team at Build Web IT",
  },
];

export type WhyJoinUsKey =
  | "fastGrowing"
  | "greatColleagues"
  | "keepLearning"
  | "latestStack"
  | "takeCharge"
  | "crossDomain";

/** Structural-only — icons paired with dict keys. */
export const whyJoinUsItems: { key: WhyJoinUsKey; icon: string }[] = [
  { key: "fastGrowing", icon: "/assets/career/join-us/graph_increase.svg" },
  { key: "greatColleagues", icon: "/assets/career/join-us/employees.svg" },
  { key: "keepLearning", icon: "/assets/career/join-us/learning.svg" },
  { key: "latestStack", icon: "/assets/career/join-us/technology.svg" },
  { key: "takeCharge", icon: "/assets/career/join-us/management.svg" },
  { key: "crossDomain", icon: "/assets/career/join-us/domain.svg" },
];

export const jobPostData: JobPostProps[] = [];
